<ul class="monitoring-type-list">
  <li class="monitoring-type-list__item">
    <a routerLink="list" class="link no-underline" routerLinkActive="dotted">Список бригад</a>
  </li>
  <li class="monitoring-type-list__item">
    <a routerLink="map" class="link no-underline" routerLinkActive="dotted">Карта</a>
  </li>
</ul>

<router-outlet></router-outlet>
